import { connect } from 'react-redux';
import GroupsList from 'comp/left/chat_list';
import { getGroupList } from 'selectors';

const mapToProps = state => ({
  list: getGroupList(),
  selected:  state.ui.selected_group,
  is_groups: true
});

export default connect(mapToProps)(GroupsList);



// WEBPACK FOOTER //
// ./src/containers/left/GroupsList.js